export const AUTH_LOGIN = 'VARUNA.AUTH_LOGIN'
export const AUTH_LOGIN_FAIL = 'VARUNA.AUTH_LOGIN_FAIL'
export const AUTH_LOGIN_SUCCESS = 'VARUNA.AUTH_LOGIN_SUCCESS'
export const AUTH_LOGOUT = 'VARUNA.AUTH_LOGOUT'
export const AUTH_REGISTER_USER = 'VARUNA.AUTH_REGISTER_USER'
export const AUTH_GET_PROFILE = 'VARUNA.AUTH_GET_PROFILE'
export const AUTH_CHANGE_PASSWORD = 'VARUNA.AUTH_CHANGE_PASSWORD'
